export const LOCATIONS_ROOT = '/locations'

export const CREATE_LOCATION = '/locations/new'
export const EDIT_LOCATION = '/location/:id'

export const LOCATIONS_CLOSED_DATES = '/locations/closed-dates'